import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { MemoryHistory } from 'history';
import config from 'config';

import { networkConnected } from 'actions/network';

import device from 'common/support/device';
import { VideoCtvRedux } from '../store-types';

const INTERVAL_DELAY = config.network.intervalDelay || 10000;

export const useCheckNetworkInterval = (): void => {
  const history = useHistory() as MemoryHistory;
  const dispatch = useDispatch();

  const isNetworkConnected = useSelector(
    (state: VideoCtvRedux) => state.network.networkConnected,
  );

  const timerInterval = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    if (!isNetworkConnected) {
      timerInterval.current = setInterval(async () => {
        (device.getDeviceNetworkConnection() as Promise<boolean>).then(connected => {
          if (connected) {
            dispatch(networkConnected());
          }
        });
      }, INTERVAL_DELAY);
    }
    return () => {
      clearInterval(timerInterval.current);
    };
  }, [isNetworkConnected, history, dispatch]);
};
